
function hideBreadcrumbSectionIfNeeded() {
    if (document.querySelector('.new-collection-main')) {
        var breadcrumbSection = document.querySelector('.breadcrumb-section-header');
        if (breadcrumbSection) {
            var section = breadcrumbSection.closest('section');
            if (section) {
                section.style.display = 'none';
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    hideBreadcrumbSectionIfNeeded();

    // Observe DOM changes to handle dynamic rendering
    var observer = new MutationObserver(function () {
        hideBreadcrumbSectionIfNeeded();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
